// ══════════════════════════════════════════════════════════════
// COMPASS – Toast Effects (side-effect only, no reducer)
// ══════════════════════════════════════════════════════════════
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { ToastActions } from './toast.actions';
import { NotificationService } from '../../../shared/notifications/notification.service';

@Injectable()
export class ToastEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationService = inject(NotificationService);

  readonly showToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ToastActions.showToast),
        tap(({ message, messageParams, title, notificationType, duration, showClose, action }) => {
          this.notificationService.show({
            message,
            messageParams,
            title,
            type: notificationType,
            duration,
            showClose,
            action,
          });
        })
      ),
    { dispatch: false }
  );
}
